export const MOBILE_MAX_WIDTH = 1024;
export const MORE_DROPDOWN_MAX_WIDTH = 1388;
